(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brx-collectors-banner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (!root || root.dataset.brxCollectorsReady === 'true') return;
      const track = root.querySelector('[data-brx-collectors-track]');
      const viewport = root.querySelector('[data-brx-collectors-viewport]');
      const slides = Array.from(root.querySelectorAll('[data-brx-collectors-slide]'));
      if (!track || slides.length === 0) return;
      root.dataset.brxCollectorsReady = 'true';
      const prev = root.querySelector('[data-brx-collectors-prev]');
      const next = root.querySelector('[data-brx-collectors-next]');
      const current = root.querySelector('[data-brx-collectors-current]');
      const progress = root.querySelector('[data-brx-collectors-progress]');
      const autoplay = root.dataset.autoplay === 'true';
      const pauseHover = root.dataset.pauseHover === 'true';
      const seconds = Math.max(4, Number(root.dataset.autoplaySeconds || 7));
      let index = 0;
      let timer = null;
      let startX = null;
      const pad = (value) => String(value).padStart(2, '0');
      const render = (nextIndex, resetTimer) => {
        index = (nextIndex + slides.length) % slides.length;
        track.style.transform = `translate3d(-${index * 100}%,0,0)`;
        slides.forEach((slide, slideIndex) => slide.setAttribute('aria-hidden', slideIndex === index ? 'false' : 'true'));
        if (current) current.textContent = pad(index + 1);
        if (progress) progress.style.transform = `scaleX(${(index + 1) / slides.length})`;
        if (resetTimer && autoplay) restart();
      };
      const stop = () => { if (timer) window.clearInterval(timer); timer = null; };
      const start = () => { if (!autoplay || slides.length < 2 || timer) return; timer = window.setInterval(() => render(index + 1, false), seconds * 1000); };
      const restart = () => { stop(); start(); };
      prev?.addEventListener('click', () => render(index - 1, true));
      next?.addEventListener('click', () => render(index + 1, true));
      if (viewport && slides.length > 1) {
        viewport.addEventListener('pointerdown', (event) => { if (event.pointerType === 'mouse' && event.button !== 0) return; startX = event.clientX; });
        viewport.addEventListener('pointerup', (event) => { if (startX === null) return; const delta = event.clientX - startX; startX = null; if (Math.abs(delta) < 45) return; render(index + (delta < 0 ? 1 : -1), true); });
        viewport.addEventListener('pointercancel', () => { startX = null; });
      }
      if (autoplay && pauseHover) { root.addEventListener('mouseenter', stop); root.addEventListener('mouseleave', start); root.addEventListener('focusin', stop); root.addEventListener('focusout', start); }
      root.brxCollectorsGoTo = (slideIndex) => render(slideIndex, false);
      render(0, false);
      start();
    };
    const initAll = (scope = document) => { if (scope.matches && scope.matches('[data-brx-collectors]')) init(scope); if (scope.querySelectorAll) scope.querySelectorAll('[data-brx-collectors]').forEach(init); };
    initAll();
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
    document.addEventListener('shopify:block:select', (event) => { const slide = event.target.closest('[data-brx-collectors-slide]'); const root = event.target.closest('[data-brx-collectors]'); if (!slide || !root || typeof root.brxCollectorsGoTo !== 'function') return; root.brxCollectorsGoTo(Number(slide.dataset.slideIndex || 0)); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brx-product-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!window.__brxProductTabsBound) {
    window.__brxProductTabsBound = true;

    const mobileQuery = window.matchMedia('(max-width: 749px)');

    const getSelectedKey = (root) =>
      root.querySelector('[data-brx-tab-target][aria-selected="true"]')?.dataset.brxTabTarget ||
      root.querySelector('[data-brx-tab-panel]')?.dataset.brxTabPanel;

    const updateDesktopSelection = (root, key, moveFocus = false) => {
      root.querySelectorAll('[data-brx-tab-target]').forEach((tab) => {
        const selected = tab.dataset.brxTabTarget === key;
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        tab.tabIndex = selected ? 0 : -1;
        tab.classList.toggle('is-active', selected);
        if (selected && moveFocus) tab.focus();
      });
    };

    const updatePanels = (root, activeKey) => {
      const isMobile = mobileQuery.matches;
      const tabs = Array.from(root.querySelectorAll('[data-brx-tab-target]'));
      const accordions = Array.from(root.querySelectorAll('[data-brx-accordion-target]'));

      accordions.forEach((button) => {
        button.setAttribute(
          'aria-expanded',
          button.dataset.brxAccordionTarget === activeKey ? 'true' : 'false'
        );
      });

      root.querySelectorAll('[data-brx-tab-panel]').forEach((panel) => {
        const key = panel.dataset.brxTabPanel;
        const isOpen = key === activeKey;
        if (isMobile) {
          // Keep panels rendered so their grid rows can animate.
          panel.hidden = false;
          panel.inert = !isOpen;
          panel.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
        } else {
          panel.inert = false;
          panel.removeAttribute('aria-hidden');
          panel.hidden = !isOpen;
        }
        const labelButton = isMobile
          ? accordions.find((button) => button.dataset.brxAccordionTarget === key)
          : tabs.find((button) => button.dataset.brxTabTarget === key);
        if (labelButton) panel.setAttribute('aria-labelledby', labelButton.id);
        panel.setAttribute('role', isMobile ? 'region' : 'tabpanel');
      });
    };

    const activateDesktopTab = (button, moveFocus = false) => {
      if (mobileQuery.matches) return;
      const root = button.closest('[data-brx-product-tabs]');
      if (!root) return;
      const key = button.dataset.brxTabTarget;
      root.dataset.brxAllAccordionsClosed = 'false';
      updateDesktopSelection(root, key, moveFocus);
      updatePanels(root, key);
    };

    // Hold a tapped heading at its on-screen position while a panel above
    // collapses. Without this, long product descriptions move it out of view.
    let anchorFrame = null;
    const cancelAnchor = () => {
      if (anchorFrame !== null) window.cancelAnimationFrame(anchorFrame);
      anchorFrame = null;
    };

    const anchorHeading = (heading, initialTop) => {
      const started = performance.now();
      const frame = (now) => {
        anchorFrame = null;
        if (!mobileQuery.matches || !heading.isConnected) return;
        const shift = heading.getBoundingClientRect().top - initialTop;
        if (Math.abs(shift) > 0.5) {
          window.scrollBy({ top: shift, left: 0, behavior: 'instant' });
        }
        if (now - started < 400) anchorFrame = window.requestAnimationFrame(frame);
      };
      anchorFrame = window.requestAnimationFrame(frame);
    };

    const toggleMobileAccordion = (button) => {
      if (!mobileQuery.matches) return;
      const root = button.closest('[data-brx-product-tabs]');
      if (!root) return;
      cancelAnchor();

      const key = button.dataset.brxAccordionTarget;
      const isAlreadyOpen = button.getAttribute('aria-expanded') === 'true';
      const headings = Array.from(root.querySelectorAll('[data-brx-accordion-target]'));
      const previous = headings.find((heading) => heading.getAttribute('aria-expanded') === 'true');
      const previousAbove = previous && headings.indexOf(previous) < headings.indexOf(button);
      const headingTop = button.getBoundingClientRect().top;

      if (isAlreadyOpen) {
        root.dataset.brxAllAccordionsClosed = 'true';
        updatePanels(root, null);
        return;
      }

      root.dataset.brxAllAccordionsClosed = 'false';
      updateDesktopSelection(root, key);
      updatePanels(root, key);
      if (previousAbove) anchorHeading(button, headingTop);
    };

    const initRoot = (root) => {
      if (root.dataset.brxTabsReady === 'true') return;
      root.dataset.brxTabsReady = 'true';
      const key = getSelectedKey(root);
      if (!key) return;
      updateDesktopSelection(root, key);
      updatePanels(root, key);
    };

    const initAll = () => {
      document.querySelectorAll('[data-brx-product-tabs]').forEach(initRoot);
    };

    const syncOnBreakpointChange = () => {
      document.querySelectorAll('[data-brx-product-tabs]').forEach((root) => {
        const opened = root.querySelector('[data-brx-accordion-target][aria-expanded="true"]');
        const key = opened?.dataset.brxAccordionTarget || getSelectedKey(root);
        if (!key) return;
        cancelAnchor();
        updateDesktopSelection(root, key);
        updatePanels(root, mobileQuery.matches && root.dataset.brxAllAccordionsClosed === 'true' ? null : key);
      });
    };

    document.addEventListener('click', (event) => {
      const accordion = event.target.closest('[data-brx-accordion-target]');
      if (accordion) {
        toggleMobileAccordion(accordion);
        return;
      }

      const tab = event.target.closest('[data-brx-tab-target]');
      if (tab) activateDesktopTab(tab);
    });

    document.addEventListener('keydown', (event) => {
      if (mobileQuery.matches) return;
      const tab = event.target.closest('[data-brx-tab-target]');
      if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;

      const root = tab.closest('[data-brx-product-tabs]');
      if (!root) return;
      const buttons = Array.from(root.querySelectorAll('[data-brx-tab-target]'));
      const currentIndex = buttons.indexOf(tab);
      if (currentIndex < 0) return;

      event.preventDefault();
      let nextIndex = currentIndex;
      if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % buttons.length;
      if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + buttons.length) % buttons.length;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = buttons.length - 1;

      activateDesktopTab(buttons[nextIndex], true);
    });

    if (mobileQuery.addEventListener) {
      mobileQuery.addEventListener('change', syncOnBreakpointChange);
    } else {
      mobileQuery.addListener(syncOnBreakpointChange);
    }
    document.addEventListener('wheel', cancelAnchor, { passive: true });
    document.addEventListener('touchmove', cancelAnchor, { passive: true });
    document.addEventListener('shopify:section:load', initAll);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll, { once: true });
    } else {
      initAll();
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
